import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useEventsState() {
  return useAppState();
}

export function useEventsActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      eventData: [],
      lastPageViewed: 0,
      canViewMoreEvents: true,
      eventWizardOpen: false,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => {
      if (response.feedbackVariant === 'success') {
        return {
          ...appState,
          eventData: (appState.eventData || []).concat(response.events || []),
          lastPageViewed: response.pageNumber || appState.lastPageViewed || 0,
          canViewMoreEvents: response.canViewMoreEvents !== undefined ? response.canViewMoreEvents : (appState.canViewMoreEvents ?? true),
          loading: false,
          feedbackMessage: response.feedbackMessage || null,
          feedbackVariant: response.feedbackVariant || null,
        };
      } else {
        return {
          ...appState,
          loading: false,
          feedbackMessage: response.feedbackMessage || null,
          feedbackVariant: response.feedbackVariant || null,
        };
      }
    });
  }

  function onError(feedback) {
    dispatch((appState) => ({
      ...appState,
      loading: false,
      feedbackMessage: feedback.feedbackMessage || null,
      feedbackVariant: feedback.feedbackVariant || null,
    }));
  }

  function setEventWizardOpen(open) {
    dispatch((appState) => ({
      ...appState,
      eventWizardOpen: open,
    }));
  }

  function getFeedbackFromLocalStorage(feedbackMessage, feedbackVariant) {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: feedbackMessage,
      feedbackVariant: feedbackVariant,
    }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    setEventWizardOpen,
    getFeedbackFromLocalStorage,
    clearFeedback,
  };
}
